import App from 'app/app.js';
import 'app/service/EventService.js';

function SessionTimeoutAction(EventService) {
  this.eventName = 'sessionTimeout';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('SessionTimeoutAction', ['EventService', SessionTimeoutAction]);
